import { InventoryCountStatus } from "@/enums";

export const inventoryCountStatuses = {
  [InventoryCountStatus.UNKNOWN]: "Unknown",
  [InventoryCountStatus.OPEN]: "Open",
  [InventoryCountStatus.CLOSED]: "Closed",
};
